import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import classes from "./Cartsidebar.module.css";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { toast } from "react-toastify";
import times from "../../../assets/cartimgs/times.svg";
import {
  addTocart,
  changeQuantity,
  decreamentQuantity,
  increamentQuantity,
} from "../../redux/productSlice";
import { useNavigate } from '@hooks/useNavigate';
import axios from "axios";
import AuthContext from "../authContext";
import { cartTotals, lineUnitAmounts, formatMoney } from "../../../utils/cartPricing";

export default function CartSidebar({ toggle, isOpen }) {
  const currency = useSelector(
    (state) => state.products.selectedCurrency[0].currency
  );
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const user = useSelector((state) => state.products.userInfo);
  const productData = useSelector((state) => state.products.productData);
  const [totalAmt, setTotalAmt] = React.useState(0);
  const [TVA, setTVA] = React.useState(0);
  const dispatch = useDispatch();
  
  const [isLoading, setIsLoading] = React.useState(false);
  const authCtx = React.useContext(AuthContext);
  const [localQuantities, setLocalQuantities] = React.useState({});
  const navigate = useNavigate();
  

  React.useEffect(() => {
    const initialQuantities = productData.reduce((acc, item) => {
      acc[item.cart_id] = item.quantity;
      return acc;
    }, {});
    setLocalQuantities(initialQuantities);
  }, [productData]);

  const handleInputChange = (id, value, maxQuantity) => {
    // Ensure only numeric values are parsed
    let numericValue = parseInt(value.replace(/\D/g, ''), 10) || 1; // Remove non-numeric characters
    let adjustedValue = Math.max(1, Math.min(maxQuantity, numericValue));
  
    // If the value exceeds maxQuantity, show a toast message
    if (adjustedValue > maxQuantity) {
      // Uncomment this for toast notifications
      // toast.info(
      //   language === "eng"
      //     ? "No more items in stock"
      //     : "Plus d'articles en stock",
      //   {
      //     position: "top-right",
      //     autoClose: 1500,
      //     hideProgressBar: true,
      //     theme: "colored",
      //   }
      // );
    }

    setLocalQuantities((prev) => ({
      ...prev,
      [id]: adjustedValue,
    }));
  };

  const updateQuantity = (item) => {
    if (!isLoading) {
      const key = item.cart_id;
      const newQuantity = localQuantities[key];

      if (newQuantity === undefined || newQuantity === null) {
        return;
      }

      
      // Find if product already exists in the cart (match by id and variants)
      let userexistingarticle = null;
      if (item.article_variant_combination) {
        userexistingarticle = productData.find(existitem => 
          item?._id === existitem._id && item.article_variant_combination?.id === existitem.article_variant_combination?.id
        );
      } else {
        userexistingarticle = productData.find(existitem => item?._id === existitem._id);
      }


    if (newQuantity !== item.quantity) {
    if (!user?.id) {
      dispatch(
        changeQuantity({
          ...userexistingarticle,
          quantity: newQuantity,
        })
      );
      return;
    }

    setIsLoading(true)
      axios
        .put(`${import.meta.env.VITE_TESTING_API}/cart/${item.cart_id}`, {
          quantity: newQuantity,
        })
        .then(() => {
          dispatch(
            changeQuantity({
              ...userexistingarticle,
              quantity: newQuantity,
            })
          );
        })
        .catch((error) => {
          // console.log(error)
          toast.error(
            language === "eng"
              ? "Failed to update item quantity."
              : "Échec de la mise à jour de la quantité.",
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              theme: "colored",
            }
          );
        }).finally(
          setTimeout(() => {
            setIsLoading(false);
          }, 1000)
        );
    }

    }
  };

  const handleKeyPress = (e, item) => {
    if (e.key === "Enter" || e.key === "Tab") {
      updateQuantity(item);
    }
  };

  const handleBlur = (item) => {
    updateQuantity(item);
  };
 

  // totalAmt/TVA are always kept in EUR (the currency articles are priced
  // in) — see src/utils/cartPricing.js, the same shared module Cart.jsx and
  // CheckOut.jsx use. This sidebar previously had its own independent copy
  // of the totals math (now removed) that: rounded per-line before summing
  // (drifting from the Cart page's total for the same cart), and re-applied
  // authCtx.currencyRate a second time at render for USD even though
  // totalAmt was already dollar-converted here — a double conversion. On
  // top of that, the HT/TVA/TTC rows below were all rendering the literal
  // same expression, so they always showed identical numbers regardless of
  // what the real HT or TVA was.
  React.useEffect(() => {
    const totals = cartTotals(productData);
    setTotalAmt(totals.ttc);
    setTVA(totals.tva);
  }, [productData]);

  const list = (anchor) => (
    <>
      <Box
        role="presentation"
        //   onClick={toggle}
        // onKeyDown={toggle}
        className={classes.container}
      >
        <List style={{ background: "#fff" }}>
          <ListItem disablePadding>
            {/* <ListItemButton> */}
            <ListItemText
              style={{
                position:'relative',
                textAlign: "start",
              }}
            >
              <div className={classes.header}>
              <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                <h1 style={{ fontSize: "calc(1.8rem + 0.6vw)",color:'var(--secondary-color)', display: "flex" }}>{language === "eng" ? "Cart" : "Panier"}</h1>
                  <div style={{ margin: "auto 0" ,cursor:"pointer"}}>
                    <img loading="lazy" src={times} srcSet={times} style={{width:'1.3em'}} alt="" onClick={toggle} />
                  </div>
                  </div>
                <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                  <p style={{ fontWeight:'600', margin:' auto 0',fontSize: "calc(.6rem + 0.3vw)"}}>HT</p>
                  <p style={{ fontWeight:'600',margin:'auto 0',fontSize: "calc(.6rem + 0.3vw)",color:'var(--secondary-color)'}}>{formatMoney(totalAmt - TVA, currency, authCtx.currencyRate)}{currency === "eur" ? "€" : "$"}</p>
                </div>
                <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                  <p style={{ fontWeight:'600',margin:'auto 0',fontSize: "calc(.6rem + 0.3vw)"}}>Total TVA</p>
                  <p style={{ fontWeight:'600',margin:'auto 0',fontSize: "calc(.6rem + 0.3vw)",color:'var(--secondary-color)'}}>{formatMoney(TVA, currency, authCtx.currencyRate)}{currency === "eur" ? "€" : "$"}</p>
                </div>
                <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-between',borderBottom:'1px solid #D9D9D9',paddingBottom:'1em'}}>
                  <p style={{ fontWeight:'600',margin:'auto 0',fontSize: "calc(.6rem + 0.3vw)"}}>Total TTC</p>
                  <p style={{ fontWeight:'600',margin:'auto 0',fontSize: "calc(1.2rem + 0.3vw)",color:'var(--secondary-color)'}}>{formatMoney(totalAmt, currency, authCtx.currencyRate)}{currency === "eur" ? "€" : "$"}</p>
                </div>
                {/* <h3>{productData ? `Your cart has ${productData.length} items` : ''}</h3> */}
                {/* <h3>
                  {language === "eng"
                    ? "you have €88 left to benefit from FREE delivery"
                    : "il vous reste 88€ pour profiter de la livraison GRATUITE"}
                </h3> */}
              </div>
            </ListItemText>
            {/* </ListItemButton> */}
          </ListItem>
        </List>
        <div className={classes.margin}>
          {productData?.map((props) => {
            return (
              <List>
                <ListItem disablePadding>
                  {/* <ListItemButton> */}
                  <ListItemText
                    style={{
                      textAlign: "center",
                      padding: "0 3%",
                    }}
                  >
                    <div className={classes.card} key={props.cart_id} style={{  position:'relative',overflow:'hidden'}} >
                      {props?.removed && <div className={classes.removed_item}>
                        <p>{language === "eng" ? "NOT AVAILABLE ANYMORE!" : "N'EST PLUS DISPONIBLE !"}</p>
                      </div>} 
                      <div style={{ margin: "auto .5em auto 0" ,position:'relative'}}>
                     {props._qte_a_terme_calcule < 1 && <div style={{cursor:'pointer'}} className={classes.out_of_stock}>
                        <p>{props?.is_coming_soon ? (language === "eng" ? "Coming Soon" : "Bientôt Disponible") : (language === "eng" ? "OUT OF STOCK" : "HORS STOCK")}</p>
                      </div>}
                        <img loading="lazy" src={props.image} srcSet={props.image} alt="" className={classes.image} />
                      </div>
                      <div>
                        <div className={classes.carddata}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              rowGap: ".1em",
                              textAlign: "start",
                            }}
                          >
                            <p className={classes.font_size} style={{fontWeight: "600"}}>{props.title?.slice(0,150)}{props.title?.length >150 && '...'}</p>
                            <div className={classes.variants} onClick={()=>console.log(props?.cart_items_variants)                            }>
                              {props?.cart_items_variants?.map((item,index)=>{
                                return(
                                  <p onClick={()=>console.log(item)} style={{padding:index === 0 && "0"}}> <span style={{textTransform:'capitalize'}}>{item?.articlevariant?.nom}:</span> {item?.variantitem?.value} {props?.cart_items_variants?.length - 1 !== index && " | "} </p>
                                )
                              })}
                              </div>
                              
                            <p className={classes.font_size}>
                             {language === "eng" ? "Price" : "Prix"}:{" "}
                            <span style={{fontWeight:"600"}} >  {formatMoney(lineUnitAmounts(props).ttc, currency, authCtx.currencyRate)}{currency === "eur" ? "€" : "$"}{" "}   {props.discount > 0 && <span
                                style={{
                                  color: "var(--primary-color)",
                                  textDecoration: "line-through",
                                  fontSize: "meduim",
                                  margin:'0'
                                }}
                              >
                                {" "}{formatMoney(Number(props.price_ttc) || 0, currency, authCtx.currencyRate)}{currency === "eur" ? "€" : "$"}
                              </span>}
                              </span>
                            </p>
                          </div>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr",
                              rowGap: ".2em",
                              textAlign: "start",
                            }}
                          >
                          <p className={classes.font_size} style={{fontWeight:"600",textAlign:'end',fontSize:'calc(1rem + 0.4vw)',color:'var(--secondary-color)'}}>
                             {" "}{formatMoney(lineUnitAmounts(props).ttc * (Number(props.quantity) || 0), currency, authCtx.currencyRate)}{currency === "eur" ? "€" : "$"}
                                                        </p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: "0em",
                            marginBottom: "1em",
                          }}
                        >
                          {props._qte_a_terme_calcule > 0 ?
                          <div style={{display:"flex",flexDirection:'row',margin:"auto",width:"100%"}}>
                          <div className={classes.quantity}>
                          <p
                            style={{
                              color: "var(--primary-color)",
                              fontWeight: 500,
                              margin: "auto",
                              fontSize: "calc(1rem + 0.3vw)",
                              cursor: isLoading ? "wait" : 'pointer',
                            }}
                            onClick={() => {
                              if (props.quantity != 1) {
                                if (!isLoading) {
                                  if (!user?.id) {
                                    dispatch(
                                      decreamentQuantity({
                                        _id: props.cart_id,
                                        title: props.name,
                                        author: props.author,
                                        image: props.image,
                                        price: props.price,
                                        quantity: 1,
                                        description: props.resume,
                                      })
                                    );
                                    return;
                                  }

                                  setIsLoading(true);
                                const item = productData.find(
                                  (item) => item.cart_id === props.cart_id
                                );
                                const newQuantity = props.quantity - 1;
                                axios
                                  .put(
                                    `${import.meta.env.VITE_TESTING_API}/cart/${item.cart_id}`,
                                    {
                                      quantity: newQuantity,
                                    }
                                  )
                                  .then((response) => {
                                    // console.log("PUT request successful:", response.data);
                                    dispatch(
                                      decreamentQuantity({
                                        _id: props.cart_id,
                                        title: props.name,
                                        author: props.author,
                                        image: props.image,
                                        price: props.price,
                                        quantity: 1,
                                        description: props.resume,
                                      })
                                    );
                                  })
                                  .catch((error) => {
                                    // console.error("Error in PUT request:", error);
                                    toast.error(`${language === 'eng' ? "Failed to remove item from cart." : "Échec de la suppression de l'article du panier."}`, {
                                      position: "top-right",
                                      autoClose: 1500,
                                      hideProgressBar: true,
                                      closeOnClick: true,
                                      pauseOnHover: true,
                                      draggable: true,
                                      progress: 0,
                                      theme: "colored",
                                    });
                                  }).finally(
                                    setTimeout(() => {
                                      setIsLoading(false);
                                    }, 1000)
                                  );
                                }
                              } else {
                                // setShowPopup(props._id)
                                // authCtx.deleteFromcart(props._id);
                              }
                            }}
                          >
                            -
                          </p>
                          <p
                            style={{
                              color: "#272E38",
                              fontWeight: 500,
                              fontSize: "calc(.9rem + 0.3vw)",
                              margin: "auto",
                            }}
                          >
                            <input
                            type="number"
                            value={localQuantities[props.cart_id] || ""}
                            onChange={(e) =>
                              handleInputChange(
                                props.cart_id,
                                e.target.value,
                                props?.article_variant_combination?.id ? props.article_variant_combination?.quantity : props._qte_a_terme_calcule
                              )
                            }
                            onBlur={() => handleBlur(props)} // Trigger when leaving input
                            onKeyPress={(e) => handleKeyPress(e, props)} // Trigger when pressing Enter or Tab
                            style={{
                                color: "#272E38",
                                fontWeight: 500,
                                fontSize: "calc(.8rem + 0.3vw)",
                                margin: "auto",
                                width: "50px",
                                textAlign: "center",
                                backgroundColor: "transparent",
                                border: "none",
                                outline: "none",
                              }}
                            />
                          </p>
                          <p
                            style={{
                              color: "var(--primary-color)",
                              fontWeight: 500,
                              margin: "auto",
                              fontSize: "calc(1rem + 0.3vw)",
                              cursor: Number(props.quantity) >= Number(props?.article_variant_combination?.id ? props.article_variant_combination?.quantity : props._qte_a_terme_calcule) ? 'not-allowed' : isLoading ? "wait" : 'pointer',
                              opacity: Number(props.quantity) >= Number(props?.article_variant_combination?.id ? props.article_variant_combination?.quantity : props._qte_a_terme_calcule) ? '0.3' : '1',
                            }}
                            onClick={() => {
                              const item = productData.find(
                                (item) => item.cart_id === props.cart_id
                              );
                              if (Number(item.quantity)  < Number(item.article_variant_combination?.id ? item.article_variant_combination?.quantity : item._qte_a_terme_calcule)) {
                                if (!isLoading) {
                                  if (!user?.id) {
                                    dispatch(
                                      increamentQuantity({
                                        _id: props.cart_id,
                                        title: props.name,
                                        author: props.author,
                                        image: props.image,
                                        price: props.price,
                                        quantity: 1,
                                        description: props.resume,
                                      })
                                    );
                                    return;
                                  }

                                  setIsLoading(true);
                              const newQuantity = props.quantity + 1;
                              axios
                                .put(
                                  `${import.meta.env.VITE_TESTING_API}/cart/${item.cart_id}`,
                                  {
                                    quantity: newQuantity,
                                  }
                                )
                                .then((response) => {
                                  // console.log("PUT request successful:", response.data);
                                  dispatch(
                                    increamentQuantity({
                                      _id: props.cart_id,
                                      title: props.name,
                                      author: props.author,
                                      image: props.image,
                                      price: props.price,
                                      quantity: 1,
                                      description: props.resume,
                                    })
                                  );
                                })
                                .catch((error) => {
                                  // console.error("Error in PUT request:", error);
                                  toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
                                    position: "top-right",
                                    autoClose: 1500,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: 0,
                                    theme: "colored",
                                  });
                                }).finally(
                                  setTimeout(() => {
                                    setIsLoading(false);
                                  }, 1000)
                                );
                              }
                              }
                            }}
                          >
                            +
                          </p>
                        </div>
                        <p style={{ margin: "1em 0 0 0",textAlign:'start',color:props._qte_a_terme_calcule > 0 ? "#2DB224" : "#EE5858",fontWeight:"600" }}>{props._qte_a_terme_calcule > 0 ? `in stock` : `${language === "eng" ? "OUT OF STOCK" : "HORS STOCK"}`} </p>
                          </div> : <div/>}
                          <div style={{ margin: "auto",zIndex:'50',backgroundColor:'#FFF3F3',width:'2em',height:'2em',borderRadius:'50%',display:'flex' }}>
                            <DeleteOutlineIcon
                              style={{
                                color: "#FF6B6B",
                                cursor: "pointer",
                                zIndex:"50",margin:"auto"
                              }}
                              onClick={() => authCtx.deleteFromcart(props)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </ListItemText>
                  {/* </ListItemButton> */}
                </ListItem>
              </List>
            );
          })}
        </div>
        <List>
          <ListItem disablePadding>
            {/* <ListItemButton> */}
            <ListItemText
              style={{
                textAlign: "start",
              }}
            >
              <div className={classes.btn_con}>
                <button
                  className={classes.btn}
                  onClick={() => navigate(`/cart`) & toggle()}
                >
                  {language === "eng" ? "Place the order" : "Passez la commande"}
                </button>
              </div>
            </ListItemText>
            {/* </ListItemButton> */}
          </ListItem>
        </List>
      </Box>
    </>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer anchor={anchor} open={isOpen} onClose={toggle}>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
